module.exports = __webpack_public_path__ + "img/FullLogoNoBackground.17f47ed8.png";